import moment from 'moment';
let searchDate = moment().startOf('year').format('YYYY');

export default {
	searchParams: SEARCH_PARAMS(),
	pagingInfo: PAGING_INFO(), //페이지 정보
	pmcSaleListScrId: '', //차량판매정보 scrId

	carScnList: [], //검색 차량구분 셀렉트박스
	pacScnList: [], //검색 승상구분 셀렉트박스
	plntCdList: [], //검색 생산공장 셀렉트박스
	flclSpcList: [], //검색 연료전지사양 셀렉트박스
	saleNatList: [], //검색 판매국가 셀렉트박스
	occuRegnList: [], //검색 판매지역 셀렉트박스

	grdList: [], //그리드리스트
	dayCols: [] //그리드 컬럼(년월컬럼)
};

function SEARCH_PARAMS() {
	return {
		carScn: '', //차량구분
		pacScn: '', //승상구분
		flclSpc: '', //연료전지사양
		saleRegn: '', //판매지역

		searchDate: searchDate //기준년도
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 10,
		startPage: 1,
		totalSize: 1
	};
}

export { SEARCH_PARAMS, PAGING_INFO };
